import { IntlShape } from "react-intl/src/types";
import {
  ManagedBy,
  PrimaryAction,
  SampleType,
  TestCard,
} from "@app/provider/testData/types";
import { messages } from "@app/provider/testData/messages";
import { OrganHealthTestCardBase } from "@app/provider/testData/testCard/organHealth/OrganHealthTestCardBase";

export class RenasightTestCard extends OrganHealthTestCardBase {
  protected getDescriptionForTestOrdered(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (testCard.managedBy !== ManagedBy.NATERA) {
      return intl.formatMessage(messages.testCardDescOrderedClinic);
    }

    if (testCard.sampleType === SampleType.BLOOD) {
      return intl.formatMessage(messages.testCardBloodDrawTestOrdered);
    }

    return intl.formatMessage(messages.testCardDescOrderedNatera);
  }

  protected getPrimaryActionForTestOrdered(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (
      testCard.sampleType === SampleType.BLOOD &&
      testCard.managedBy !== ManagedBy.CLINIC
    ) {
      return PrimaryAction.SCHEDULE_A_DRAW;
    }
  }

  protected getPrimaryActionForKitShipped(
    testCard: TestCard
  ): PrimaryAction | undefined {
    if (testCard.sampleType === SampleType.SALIVA) {
      return PrimaryAction.TRACK_KIT_STATUS;
    }
  }
}
